// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file consts/constant.proto (package constant, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";

/**
 * ComparisonOperator represents int-based constants
 *
 * @generated from enum constant.ComparisonOperator
 */
export enum ComparisonOperator {
  /**
   * 0
   *
   * @generated from enum value: COMPARISON_OPERATOR_NONE = 0;
   */
  NONE = 0,

  /**
   * 1
   *
   * @generated from enum value: COMPARISON_OPERATOR_EQUAL = 1;
   */
  EQUAL = 1,

  /**
   * 2
   *
   * @generated from enum value: COMPARISON_OPERATOR_NOT_EQUAL = 2;
   */
  NOT_EQUAL = 2,

  /**
   * 3
   *
   * @generated from enum value: COMPARISON_OPERATOR_GREATER_THAN = 3;
   */
  GREATER_THAN = 3,

  /**
   * 4
   *
   * @generated from enum value: COMPARISON_OPERATOR_GREATER_THAN_OR_EQUAL = 4;
   */
  GREATER_THAN_OR_EQUAL = 4,

  /**
   * 5
   *
   * @generated from enum value: COMPARISON_OPERATOR_LESS_THAN = 5;
   */
  LESS_THAN = 5,

  /**
   * 6
   *
   * @generated from enum value: COMPARISON_OPERATOR_LESS_THAN_OR_EQUAL = 6;
   */
  LESS_THAN_OR_EQUAL = 6,

  /**
   * 7
   *
   * @generated from enum value: COMPARISON_OPERATOR_CONTAINS = 7;
   */
  CONTAINS = 7,

  /**
   * 8
   *
   * @generated from enum value: COMPARISON_OPERATOR_NOT_CONTAINS = 8;
   */
  NOT_CONTAINS = 8,
}
// Retrieve enum metadata with: proto3.getEnumType(ComparisonOperator)
proto3.util.setEnumType(ComparisonOperator, "constant.ComparisonOperator", [
  { no: 0, name: "COMPARISON_OPERATOR_NONE" },
  { no: 1, name: "COMPARISON_OPERATOR_EQUAL" },
  { no: 2, name: "COMPARISON_OPERATOR_NOT_EQUAL" },
  { no: 3, name: "COMPARISON_OPERATOR_GREATER_THAN" },
  { no: 4, name: "COMPARISON_OPERATOR_GREATER_THAN_OR_EQUAL" },
  { no: 5, name: "COMPARISON_OPERATOR_LESS_THAN" },
  { no: 6, name: "COMPARISON_OPERATOR_LESS_THAN_OR_EQUAL" },
  { no: 7, name: "COMPARISON_OPERATOR_CONTAINS" },
  { no: 8, name: "COMPARISON_OPERATOR_NOT_CONTAINS" },
]);

/**
 * ContactType represents int-based constants
 *
 * @generated from enum constant.ContactType
 */
export enum ContactType {
  /**
   * 0
   *
   * @generated from enum value: CONTACT_TYPE_NONE = 0;
   */
  NONE = 0,

  /**
   * 1
   *
   * @generated from enum value: CONTACT_TYPE_INQUIRY = 1;
   */
  INQUIRY = 1,

  /**
   * 2
   *
   * @generated from enum value: CONTACT_TYPE_BUG_REPORT = 2;
   */
  BUG_REPORT = 2,

  /**
   * 3
   *
   * @generated from enum value: CONTACT_TYPE_FEATURE_REQUEST = 3;
   */
  FEATURE_REQUEST = 3,

  /**
   * 4
   *
   * @generated from enum value: CONTACT_TYPE_OTHER = 4;
   */
  OTHER = 4,
}
// Retrieve enum metadata with: proto3.getEnumType(ContactType)
proto3.util.setEnumType(ContactType, "constant.ContactType", [
  { no: 0, name: "CONTACT_TYPE_NONE" },
  { no: 1, name: "CONTACT_TYPE_INQUIRY" },
  { no: 2, name: "CONTACT_TYPE_BUG_REPORT" },
  { no: 3, name: "CONTACT_TYPE_FEATURE_REQUEST" },
  { no: 4, name: "CONTACT_TYPE_OTHER" },
]);

/**
 * CurrencyType represents string-based constants
 *
 * @generated from enum constant.CurrencyType
 */
export enum CurrencyType {
  /**
   * "none"
   *
   * @generated from enum value: CURRENCY_TYPE_NONE = 0;
   */
  NONE = 0,

  /**
   * "free_dia"
   *
   * @generated from enum value: CURRENCY_TYPE_FREE_DIA = 1;
   */
  FREE_DIA = 1,

  /**
   * "paid_dia"
   *
   * @generated from enum value: CURRENCY_TYPE_PAID_DIA = 2;
   */
  PAID_DIA = 2,

  /**
   * "coin"
   *
   * @generated from enum value: CURRENCY_TYPE_COIN = 3;
   */
  COIN = 3,

  /**
   * "character_present_purple"
   *
   * @generated from enum value: CURRENCY_TYPE_CHARACTER_PRESENT_PURPLE = 4;
   */
  CHARACTER_PRESENT_PURPLE = 4,

  /**
   * "character_present_red"
   *
   * @generated from enum value: CURRENCY_TYPE_CHARACTER_PRESENT_RED = 5;
   */
  CHARACTER_PRESENT_RED = 5,

  /**
   * "character_present_blue"
   *
   * @generated from enum value: CURRENCY_TYPE_CHARACTER_PRESENT_BLUE = 6;
   */
  CHARACTER_PRESENT_BLUE = 6,

  /**
   * "character_sand"
   *
   * @generated from enum value: CURRENCY_TYPE_CHARACTER_SAND = 7;
   */
  CHARACTER_SAND = 7,

  /**
   * "ornament_sand"
   *
   * @generated from enum value: CURRENCY_TYPE_ORNAMENT_SAND = 8;
   */
  ORNAMENT_SAND = 8,

  /**
   * "shogi_match_ticket"
   *
   * @generated from enum value: CURRENCY_TYPE_SHOGI_MATCH_TICKET = 9;
   */
  SHOGI_MATCH_TICKET = 9,
}
// Retrieve enum metadata with: proto3.getEnumType(CurrencyType)
proto3.util.setEnumType(CurrencyType, "constant.CurrencyType", [
  { no: 0, name: "CURRENCY_TYPE_NONE" },
  { no: 1, name: "CURRENCY_TYPE_FREE_DIA" },
  { no: 2, name: "CURRENCY_TYPE_PAID_DIA" },
  { no: 3, name: "CURRENCY_TYPE_COIN" },
  { no: 4, name: "CURRENCY_TYPE_CHARACTER_PRESENT_PURPLE" },
  { no: 5, name: "CURRENCY_TYPE_CHARACTER_PRESENT_RED" },
  { no: 6, name: "CURRENCY_TYPE_CHARACTER_PRESENT_BLUE" },
  { no: 7, name: "CURRENCY_TYPE_CHARACTER_SAND" },
  { no: 8, name: "CURRENCY_TYPE_ORNAMENT_SAND" },
  { no: 9, name: "CURRENCY_TYPE_SHOGI_MATCH_TICKET" },
]);

/**
 * DataEnvironment represents string-based constants
 *
 * @generated from enum constant.DataEnvironment
 */
export enum DataEnvironment {
  /**
   * "production"
   *
   * @generated from enum value: DATA_ENVIRONMENT_PRODUCTION = 0;
   */
  PRODUCTION = 0,

  /**
   * "staging"
   *
   * @generated from enum value: DATA_ENVIRONMENT_STAGING = 1;
   */
  STAGING = 1,
}
// Retrieve enum metadata with: proto3.getEnumType(DataEnvironment)
proto3.util.setEnumType(DataEnvironment, "constant.DataEnvironment", [
  { no: 0, name: "DATA_ENVIRONMENT_PRODUCTION" },
  { no: 1, name: "DATA_ENVIRONMENT_STAGING" },
]);

/**
 * ExpireType represents int-based constants
 *
 * @generated from enum constant.ExpireType
 */
export enum ExpireType {
  /**
   * 0
   *
   * @generated from enum value: EXPIRE_TYPE_NONE = 0;
   */
  NONE = 0,

  /**
   * 1
   *
   * @generated from enum value: EXPIRE_TYPE_FIXED = 1;
   */
  FIXED = 1,

  /**
   * 2
   *
   * @generated from enum value: EXPIRE_TYPE_ELAPSED_AT_ACQUIRED = 2;
   */
  ELAPSED_AT_ACQUIRED = 2,

  /**
   * 3
   *
   * @generated from enum value: EXPIRE_TYPE_ELAPSED_AT_GIFT = 3;
   */
  ELAPSED_AT_GIFT = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(ExpireType)
proto3.util.setEnumType(ExpireType, "constant.ExpireType", [
  { no: 0, name: "EXPIRE_TYPE_NONE" },
  { no: 1, name: "EXPIRE_TYPE_FIXED" },
  { no: 2, name: "EXPIRE_TYPE_ELAPSED_AT_ACQUIRED" },
  { no: 3, name: "EXPIRE_TYPE_ELAPSED_AT_GIFT" },
]);

/**
 * FollowRequestActionType represents int-based constants
 *
 * @generated from enum constant.FollowRequestActionType
 */
export enum FollowRequestActionType {
  /**
   * 0
   *
   * @generated from enum value: FOLLOW_REQUEST_ACTION_TYPE_ACCEPT = 0;
   */
  ACCEPT = 0,

  /**
   * 1
   *
   * @generated from enum value: FOLLOW_REQUEST_ACTION_TYPE_REJECT = 1;
   */
  REJECT = 1,

  /**
   * 2
   *
   * @generated from enum value: FOLLOW_REQUEST_ACTION_TYPE_BLOCK = 2;
   */
  BLOCK = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(FollowRequestActionType)
proto3.util.setEnumType(FollowRequestActionType, "constant.FollowRequestActionType", [
  { no: 0, name: "FOLLOW_REQUEST_ACTION_TYPE_ACCEPT" },
  { no: 1, name: "FOLLOW_REQUEST_ACTION_TYPE_REJECT" },
  { no: 2, name: "FOLLOW_REQUEST_ACTION_TYPE_BLOCK" },
]);

/**
 * GiftDistributionType represents int-based constants
 *
 * @generated from enum constant.GiftDistributionType
 */
export enum GiftDistributionType {
  /**
   * 0
   *
   * @generated from enum value: GIFT_DISTRIBUTION_TYPE_NONE = 0;
   */
  NONE = 0,

  /**
   * 1
   *
   * @generated from enum value: GIFT_DISTRIBUTION_TYPE_ALL = 1;
   */
  ALL = 1,

  /**
   * 2
   *
   * @generated from enum value: GIFT_DISTRIBUTION_TYPE_USER_LIST = 2;
   */
  USER_LIST = 2,

  /**
   * 3
   *
   * @generated from enum value: GIFT_DISTRIBUTION_TYPE_CONDITIONAL = 3;
   */
  CONDITIONAL = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(GiftDistributionType)
proto3.util.setEnumType(GiftDistributionType, "constant.GiftDistributionType", [
  { no: 0, name: "GIFT_DISTRIBUTION_TYPE_NONE" },
  { no: 1, name: "GIFT_DISTRIBUTION_TYPE_ALL" },
  { no: 2, name: "GIFT_DISTRIBUTION_TYPE_USER_LIST" },
  { no: 3, name: "GIFT_DISTRIBUTION_TYPE_CONDITIONAL" },
]);

/**
 * GiftState represents int-based constants
 *
 * @generated from enum constant.GiftState
 */
export enum GiftState {
  /**
   * 0
   *
   * @generated from enum value: GIFT_STATE_NONE = 0;
   */
  NONE = 0,

  /**
   * 1
   *
   * @generated from enum value: GIFT_STATE_UNOPENED = 1;
   */
  UNOPENED = 1,

  /**
   * 2
   *
   * @generated from enum value: GIFT_STATE_OPENED = 2;
   */
  OPENED = 2,

  /**
   * 3
   *
   * @generated from enum value: GIFT_STATE_EXPIRED = 3;
   */
  EXPIRED = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(GiftState)
proto3.util.setEnumType(GiftState, "constant.GiftState", [
  { no: 0, name: "GIFT_STATE_NONE" },
  { no: 1, name: "GIFT_STATE_UNOPENED" },
  { no: 2, name: "GIFT_STATE_OPENED" },
  { no: 3, name: "GIFT_STATE_EXPIRED" },
]);

/**
 * ItemReasonType represents int-based constants
 *
 * @generated from enum constant.ItemReasonType
 */
export enum ItemReasonType {
  /**
   * 0
   *
   * @generated from enum value: ITEM_REASON_TYPE_NONE = 0;
   */
  NONE = 0,

  /**
   * 1
   *
   * @generated from enum value: ITEM_REASON_TYPE_GIFT_OPEN = 1;
   */
  GIFT_OPEN = 1,

  /**
   * 2
   *
   * @generated from enum value: ITEM_REASON_TYPE_MISSION_REWARD = 2;
   */
  MISSION_REWARD = 2,

  /**
   * 3
   *
   * @generated from enum value: ITEM_REASON_TYPE_LOGIN_BONUS = 3;
   */
  LOGIN_BONUS = 3,

  /**
   * 4
   *
   * @generated from enum value: ITEM_REASON_TYPE_SHOP_PURCHASE = 4;
   */
  SHOP_PURCHASE = 4,

  /**
   * 5
   *
   * @generated from enum value: ITEM_REASON_TYPE_EVENT_REWARD = 5;
   */
  EVENT_REWARD = 5,

  /**
   * 6
   *
   * @generated from enum value: ITEM_REASON_TYPE_MATCH_REWARD = 6;
   */
  MATCH_REWARD = 6,

  /**
   * 7
   *
   * @generated from enum value: ITEM_REASON_TYPE_RANK_REWARD = 7;
   */
  RANK_REWARD = 7,

  /**
   * 8
   *
   * @generated from enum value: ITEM_REASON_TYPE_ADMIN_GRANT = 8;
   */
  ADMIN_GRANT = 8,

  /**
   * 9
   *
   * @generated from enum value: ITEM_REASON_TYPE_ITEM_USE = 9;
   */
  ITEM_USE = 9,

  /**
   * 10
   *
   * @generated from enum value: ITEM_REASON_TYPE_ITEM_CONSUME = 10;
   */
  ITEM_CONSUME = 10,

  /**
   * 11
   *
   * @generated from enum value: ITEM_REASON_TYPE_GACHA = 11;
   */
  GACHA = 11,

  /**
   * 12
   *
   * @generated from enum value: ITEM_REASON_TYPE_EXCHANGE = 12;
   */
  EXCHANGE = 12,

  /**
   * 13
   *
   * @generated from enum value: ITEM_REASON_TYPE_EXPIRED = 13;
   */
  EXPIRED = 13,

  /**
   * 14
   *
   * @generated from enum value: ITEM_REASON_TYPE_ORNAMENT_DECOMPOSITION = 14;
   */
  ORNAMENT_DECOMPOSITION = 14,

  /**
   * 15
   *
   * @generated from enum value: ITEM_REASON_TYPE_CHARACTER_DECOMPOSITION = 15;
   */
  CHARACTER_DECOMPOSITION = 15,

  /**
   * 16
   *
   * @generated from enum value: ITEM_REASON_TYPE_SHOGI_A_IASSIST = 16;
   */
  SHOGI_A_IASSIST = 16,
}
// Retrieve enum metadata with: proto3.getEnumType(ItemReasonType)
proto3.util.setEnumType(ItemReasonType, "constant.ItemReasonType", [
  { no: 0, name: "ITEM_REASON_TYPE_NONE" },
  { no: 1, name: "ITEM_REASON_TYPE_GIFT_OPEN" },
  { no: 2, name: "ITEM_REASON_TYPE_MISSION_REWARD" },
  { no: 3, name: "ITEM_REASON_TYPE_LOGIN_BONUS" },
  { no: 4, name: "ITEM_REASON_TYPE_SHOP_PURCHASE" },
  { no: 5, name: "ITEM_REASON_TYPE_EVENT_REWARD" },
  { no: 6, name: "ITEM_REASON_TYPE_MATCH_REWARD" },
  { no: 7, name: "ITEM_REASON_TYPE_RANK_REWARD" },
  { no: 8, name: "ITEM_REASON_TYPE_ADMIN_GRANT" },
  { no: 9, name: "ITEM_REASON_TYPE_ITEM_USE" },
  { no: 10, name: "ITEM_REASON_TYPE_ITEM_CONSUME" },
  { no: 11, name: "ITEM_REASON_TYPE_GACHA" },
  { no: 12, name: "ITEM_REASON_TYPE_EXCHANGE" },
  { no: 13, name: "ITEM_REASON_TYPE_EXPIRED" },
  { no: 14, name: "ITEM_REASON_TYPE_ORNAMENT_DECOMPOSITION" },
  { no: 15, name: "ITEM_REASON_TYPE_CHARACTER_DECOMPOSITION" },
  { no: 16, name: "ITEM_REASON_TYPE_SHOGI_A_IASSIST" },
]);

/**
 * ItemType represents string-based constants
 *
 * @generated from enum constant.ItemType
 */
export enum ItemType {
  /**
   * "none"
   *
   * @generated from enum value: ITEM_TYPE_NONE = 0;
   */
  NONE = 0,

  /**
   * "free_dia_currency"
   *
   * @generated from enum value: ITEM_TYPE_FREE_DIA = 1;
   */
  FREE_DIA = 1,

  /**
   * "paid_dia_currency"
   *
   * @generated from enum value: ITEM_TYPE_PAID_DIA = 2;
   */
  PAID_DIA = 2,

  /**
   * "icon"
   *
   * @generated from enum value: ITEM_TYPE_ICON = 3;
   */
  ICON = 3,

  /**
   * "icon_frame"
   *
   * @generated from enum value: ITEM_TYPE_ICON_FRAME = 4;
   */
  ICON_FRAME = 4,

  /**
   * "shogi_board"
   *
   * @generated from enum value: ITEM_TYPE_SHOGI_BOARD = 5;
   */
  SHOGI_BOARD = 5,

  /**
   * "shogi_piece"
   *
   * @generated from enum value: ITEM_TYPE_SHOGI_PIECE = 6;
   */
  SHOGI_PIECE = 6,

  /**
   * "shogi_piece_sound"
   *
   * @generated from enum value: ITEM_TYPE_SHOGI_PIECE_SOUND = 7;
   */
  SHOGI_PIECE_SOUND = 7,

  /**
   * "shogi_effect"
   *
   * @generated from enum value: ITEM_TYPE_SHOGI_EFFECT = 8;
   */
  SHOGI_EFFECT = 8,

  /**
   * "shogi_ingame_bgm"
   *
   * @generated from enum value: ITEM_TYPE_SHOGI_INGAME_B_GM = 9;
   */
  SHOGI_INGAME_B_GM = 9,

  /**
   * "home_background"
   *
   * @generated from enum value: ITEM_TYPE_HOME_BACKGROUND = 10;
   */
  HOME_BACKGROUND = 10,

  /**
   * "character_present_currency"
   *
   * @generated from enum value: ITEM_TYPE_CHARACTER_PRESENT = 11;
   */
  CHARACTER_PRESENT = 11,

  /**
   * "ornament_sand_currency"
   *
   * @generated from enum value: ITEM_TYPE_ORNAMENT_SAND = 12;
   */
  ORNAMENT_SAND = 12,

  /**
   * "shogi_match_ticket_currency"
   *
   * @generated from enum value: ITEM_TYPE_SHOGI_MATCH_TICKET = 13;
   */
  SHOGI_MATCH_TICKET = 13,

  /**
   * "premium_pass_ticket"
   *
   * @generated from enum value: ITEM_TYPE_PREMIUM_PASS_TICKET = 14;
   */
  PREMIUM_PASS_TICKET = 14,

  /**
   * "coin_currency"
   *
   * @generated from enum value: ITEM_TYPE_COIN = 15;
   */
  COIN = 15,

  /**
   * "character_sand_currency"
   *
   * @generated from enum value: ITEM_TYPE_CHARACTER_SAND = 16;
   */
  CHARACTER_SAND = 16,

  /**
   * "character_ticket"
   *
   * @generated from enum value: ITEM_TYPE_CHARACTER_TICKET = 17;
   */
  CHARACTER_TICKET = 17,

  /**
   * "character_skin"
   *
   * @generated from enum value: ITEM_TYPE_CHARACTER_SKIN = 18;
   */
  CHARACTER_SKIN = 18,

  /**
   * "achievement_ticket"
   *
   * @generated from enum value: ITEM_TYPE_ACHIEVEMENT_TICKET = 19;
   */
  ACHIEVEMENT_TICKET = 19,
}
// Retrieve enum metadata with: proto3.getEnumType(ItemType)
proto3.util.setEnumType(ItemType, "constant.ItemType", [
  { no: 0, name: "ITEM_TYPE_NONE" },
  { no: 1, name: "ITEM_TYPE_FREE_DIA" },
  { no: 2, name: "ITEM_TYPE_PAID_DIA" },
  { no: 3, name: "ITEM_TYPE_ICON" },
  { no: 4, name: "ITEM_TYPE_ICON_FRAME" },
  { no: 5, name: "ITEM_TYPE_SHOGI_BOARD" },
  { no: 6, name: "ITEM_TYPE_SHOGI_PIECE" },
  { no: 7, name: "ITEM_TYPE_SHOGI_PIECE_SOUND" },
  { no: 8, name: "ITEM_TYPE_SHOGI_EFFECT" },
  { no: 9, name: "ITEM_TYPE_SHOGI_INGAME_B_GM" },
  { no: 10, name: "ITEM_TYPE_HOME_BACKGROUND" },
  { no: 11, name: "ITEM_TYPE_CHARACTER_PRESENT" },
  { no: 12, name: "ITEM_TYPE_ORNAMENT_SAND" },
  { no: 13, name: "ITEM_TYPE_SHOGI_MATCH_TICKET" },
  { no: 14, name: "ITEM_TYPE_PREMIUM_PASS_TICKET" },
  { no: 15, name: "ITEM_TYPE_COIN" },
  { no: 16, name: "ITEM_TYPE_CHARACTER_SAND" },
  { no: 17, name: "ITEM_TYPE_CHARACTER_TICKET" },
  { no: 18, name: "ITEM_TYPE_CHARACTER_SKIN" },
  { no: 19, name: "ITEM_TYPE_ACHIEVEMENT_TICKET" },
]);

/**
 * LobbySlotState represents string-based constants
 *
 * @generated from enum constant.LobbySlotState
 */
export enum LobbySlotState {
  /**
   * "waiting"
   *
   * @generated from enum value: LOBBY_SLOT_STATE_WAITING = 0;
   */
  WAITING = 0,

  /**
   * "playing"
   *
   * @generated from enum value: LOBBY_SLOT_STATE_PLAYING = 1;
   */
  PLAYING = 1,
}
// Retrieve enum metadata with: proto3.getEnumType(LobbySlotState)
proto3.util.setEnumType(LobbySlotState, "constant.LobbySlotState", [
  { no: 0, name: "LOBBY_SLOT_STATE_WAITING" },
  { no: 1, name: "LOBBY_SLOT_STATE_PLAYING" },
]);

/**
 * LobbyState represents string-based constants
 *
 * @generated from enum constant.LobbyState
 */
export enum LobbyState {
  /**
   * "open"
   *
   * @generated from enum value: LOBBY_STATE_OPEN = 0;
   */
  OPEN = 0,

  /**
   * "closed"
   *
   * @generated from enum value: LOBBY_STATE_CLOSED = 1;
   */
  CLOSED = 1,
}
// Retrieve enum metadata with: proto3.getEnumType(LobbyState)
proto3.util.setEnumType(LobbyState, "constant.LobbyState", [
  { no: 0, name: "LOBBY_STATE_OPEN" },
  { no: 1, name: "LOBBY_STATE_CLOSED" },
]);

/**
 * LobbyStreamAction represents string-based constants
 *
 * @generated from enum constant.LobbyStreamAction
 */
export enum LobbyStreamAction {
  /**
   * "connect"
   *
   * @generated from enum value: LOBBY_STREAM_ACTION_CONNECT = 0;
   */
  CONNECT = 0,

  /**
   * "leave"
   *
   * @generated from enum value: LOBBY_STREAM_ACTION_LEAVE = 1;
   */
  LEAVE = 1,

  /**
   * "heartbeat"
   *
   * @generated from enum value: LOBBY_STREAM_ACTION_HEARTBEAT = 2;
   */
  HEARTBEAT = 2,

  /**
   * "join_slot"
   *
   * @generated from enum value: LOBBY_STREAM_ACTION_JOIN_SLOT = 3;
   */
  JOIN_SLOT = 3,

  /**
   * "leave_slot"
   *
   * @generated from enum value: LOBBY_STREAM_ACTION_LEAVE_SLOT = 4;
   */
  LEAVE_SLOT = 4,

  /**
   * "slot_ready"
   *
   * @generated from enum value: LOBBY_STREAM_ACTION_SLOT_READY = 5;
   */
  SLOT_READY = 5,

  /**
   * "watch_match"
   *
   * @generated from enum value: LOBBY_STREAM_ACTION_WATCH_MATCH = 6;
   */
  WATCH_MATCH = 6,
}
// Retrieve enum metadata with: proto3.getEnumType(LobbyStreamAction)
proto3.util.setEnumType(LobbyStreamAction, "constant.LobbyStreamAction", [
  { no: 0, name: "LOBBY_STREAM_ACTION_CONNECT" },
  { no: 1, name: "LOBBY_STREAM_ACTION_LEAVE" },
  { no: 2, name: "LOBBY_STREAM_ACTION_HEARTBEAT" },
  { no: 3, name: "LOBBY_STREAM_ACTION_JOIN_SLOT" },
  { no: 4, name: "LOBBY_STREAM_ACTION_LEAVE_SLOT" },
  { no: 5, name: "LOBBY_STREAM_ACTION_SLOT_READY" },
  { no: 6, name: "LOBBY_STREAM_ACTION_WATCH_MATCH" },
]);

/**
 * LobbyStreamEvent represents string-based constants
 *
 * @generated from enum constant.LobbyStreamEvent
 */
export enum LobbyStreamEvent {
  /**
   * "connected"
   *
   * @generated from enum value: LOBBY_STREAM_EVENT_CONNECTED = 0;
   */
  CONNECTED = 0,

  /**
   * "room_updated"
   *
   * @generated from enum value: LOBBY_STREAM_EVENT_ROOM_UPDATED = 1;
   */
  ROOM_UPDATED = 1,

  /**
   * "spectator_joined"
   *
   * @generated from enum value: LOBBY_STREAM_EVENT_SPECTATOR_JOINED = 2;
   */
  SPECTATOR_JOINED = 2,

  /**
   * "spectator_left"
   *
   * @generated from enum value: LOBBY_STREAM_EVENT_SPECTATOR_LEFT = 3;
   */
  SPECTATOR_LEFT = 3,

  /**
   * "match_started"
   *
   * @generated from enum value: LOBBY_STREAM_EVENT_MATCH_STARTED = 4;
   */
  MATCH_STARTED = 4,

  /**
   * "lobby_closed"
   *
   * @generated from enum value: LOBBY_STREAM_EVENT_LOBBY_CLOSED = 5;
   */
  LOBBY_CLOSED = 5,

  /**
   * "host_changed"
   *
   * @generated from enum value: LOBBY_STREAM_EVENT_HOST_CHANGED = 6;
   */
  HOST_CHANGED = 6,

  /**
   * "error"
   *
   * @generated from enum value: LOBBY_STREAM_EVENT_ERROR = 7;
   */
  ERROR = 7,

  /**
   * "slot_updated"
   *
   * @generated from enum value: LOBBY_STREAM_EVENT_SLOT_UPDATED = 8;
   */
  SLOT_UPDATED = 8,

  /**
   * "match_ended"
   *
   * @generated from enum value: LOBBY_STREAM_EVENT_MATCH_ENDED = 9;
   */
  MATCH_ENDED = 9,
}
// Retrieve enum metadata with: proto3.getEnumType(LobbyStreamEvent)
proto3.util.setEnumType(LobbyStreamEvent, "constant.LobbyStreamEvent", [
  { no: 0, name: "LOBBY_STREAM_EVENT_CONNECTED" },
  { no: 1, name: "LOBBY_STREAM_EVENT_ROOM_UPDATED" },
  { no: 2, name: "LOBBY_STREAM_EVENT_SPECTATOR_JOINED" },
  { no: 3, name: "LOBBY_STREAM_EVENT_SPECTATOR_LEFT" },
  { no: 4, name: "LOBBY_STREAM_EVENT_MATCH_STARTED" },
  { no: 5, name: "LOBBY_STREAM_EVENT_LOBBY_CLOSED" },
  { no: 6, name: "LOBBY_STREAM_EVENT_HOST_CHANGED" },
  { no: 7, name: "LOBBY_STREAM_EVENT_ERROR" },
  { no: 8, name: "LOBBY_STREAM_EVENT_SLOT_UPDATED" },
  { no: 9, name: "LOBBY_STREAM_EVENT_MATCH_ENDED" },
]);

/**
 * LobbyStreamResultType represents int-based constants
 *
 * @generated from enum constant.LobbyStreamResultType
 */
export enum LobbyStreamResultType {
  /**
   * 0
   *
   * @generated from enum value: LOBBY_STREAM_RESULT_TYPE_NONE = 0;
   */
  NONE = 0,

  /**
   * 1
   *
   * @generated from enum value: LOBBY_STREAM_RESULT_TYPE_SUCCESS = 1;
   */
  SUCCESS = 1,

  /**
   * 2
   *
   * @generated from enum value: LOBBY_STREAM_RESULT_TYPE_LOBBY_NOT_FOUND = 2;
   */
  LOBBY_NOT_FOUND = 2,

  /**
   * 3
   *
   * @generated from enum value: LOBBY_STREAM_RESULT_TYPE_JOIN_FAILED = 3;
   */
  JOIN_FAILED = 3,

  /**
   * 4
   *
   * @generated from enum value: LOBBY_STREAM_RESULT_TYPE_CHANGE_ROLE_FAILED = 4;
   */
  CHANGE_ROLE_FAILED = 4,

  /**
   * 5
   *
   * @generated from enum value: LOBBY_STREAM_RESULT_TYPE_PERMISSION_DENIED = 5;
   */
  PERMISSION_DENIED = 5,

  /**
   * 6
   *
   * @generated from enum value: LOBBY_STREAM_RESULT_TYPE_CANNOT_START_MATCH = 6;
   */
  CANNOT_START_MATCH = 6,

  /**
   * 7
   *
   * @generated from enum value: LOBBY_STREAM_RESULT_TYPE_INVALID_PARAMETER = 7;
   */
  INVALID_PARAMETER = 7,

  /**
   * 8
   *
   * @generated from enum value: LOBBY_STREAM_RESULT_TYPE_SLOT_FULL = 8;
   */
  SLOT_FULL = 8,

  /**
   * 9
   *
   * @generated from enum value: LOBBY_STREAM_RESULT_TYPE_SLOT_NOT_FOUND = 9;
   */
  SLOT_NOT_FOUND = 9,

  /**
   * 10
   *
   * @generated from enum value: LOBBY_STREAM_RESULT_TYPE_ALREADY_IN_SLOT = 10;
   */
  ALREADY_IN_SLOT = 10,

  /**
   * 11
   *
   * @generated from enum value: LOBBY_STREAM_RESULT_TYPE_NOT_IN_SLOT = 11;
   */
  NOT_IN_SLOT = 11,

  /**
   * 12
   *
   * @generated from enum value: LOBBY_STREAM_RESULT_TYPE_SLOT_PLAYING = 12;
   */
  SLOT_PLAYING = 12,

  /**
   * 13
   *
   * @generated from enum value: LOBBY_STREAM_RESULT_TYPE_MATCH_NOT_FOUND = 13;
   */
  MATCH_NOT_FOUND = 13,

  /**
   * 6
   *
   * @generated from enum value: LOBBY_STREAM_RESULT_TYPE_LOBBY_INVITE_CODE_LENGTH = 14;
   */
  LOBBY_INVITE_CODE_LENGTH = 14,

  /**
   * 50
   *
   * @generated from enum value: LOBBY_STREAM_RESULT_TYPE_LOBBY_MAX_SPECTATORS = 15;
   */
  LOBBY_MAX_SPECTATORS = 15,

  /**
   * 4
   *
   * @generated from enum value: LOBBY_STREAM_RESULT_TYPE_LOBBY_MAX_SLOTS = 16;
   */
  LOBBY_MAX_SLOTS = 16,
}
// Retrieve enum metadata with: proto3.getEnumType(LobbyStreamResultType)
proto3.util.setEnumType(LobbyStreamResultType, "constant.LobbyStreamResultType", [
  { no: 0, name: "LOBBY_STREAM_RESULT_TYPE_NONE" },
  { no: 1, name: "LOBBY_STREAM_RESULT_TYPE_SUCCESS" },
  { no: 2, name: "LOBBY_STREAM_RESULT_TYPE_LOBBY_NOT_FOUND" },
  { no: 3, name: "LOBBY_STREAM_RESULT_TYPE_JOIN_FAILED" },
  { no: 4, name: "LOBBY_STREAM_RESULT_TYPE_CHANGE_ROLE_FAILED" },
  { no: 5, name: "LOBBY_STREAM_RESULT_TYPE_PERMISSION_DENIED" },
  { no: 6, name: "LOBBY_STREAM_RESULT_TYPE_CANNOT_START_MATCH" },
  { no: 7, name: "LOBBY_STREAM_RESULT_TYPE_INVALID_PARAMETER" },
  { no: 8, name: "LOBBY_STREAM_RESULT_TYPE_SLOT_FULL" },
  { no: 9, name: "LOBBY_STREAM_RESULT_TYPE_SLOT_NOT_FOUND" },
  { no: 10, name: "LOBBY_STREAM_RESULT_TYPE_ALREADY_IN_SLOT" },
  { no: 11, name: "LOBBY_STREAM_RESULT_TYPE_NOT_IN_SLOT" },
  { no: 12, name: "LOBBY_STREAM_RESULT_TYPE_SLOT_PLAYING" },
  { no: 13, name: "LOBBY_STREAM_RESULT_TYPE_MATCH_NOT_FOUND" },
  { no: 14, name: "LOBBY_STREAM_RESULT_TYPE_LOBBY_INVITE_CODE_LENGTH" },
  { no: 15, name: "LOBBY_STREAM_RESULT_TYPE_LOBBY_MAX_SPECTATORS" },
  { no: 16, name: "LOBBY_STREAM_RESULT_TYPE_LOBBY_MAX_SLOTS" },
]);

/**
 * LogicOperator represents int-based constants
 *
 * @generated from enum constant.LogicOperator
 */
export enum LogicOperator {
  /**
   * 0
   *
   * @generated from enum value: LOGIC_OPERATOR_NONE = 0;
   */
  NONE = 0,

  /**
   * 1
   *
   * @generated from enum value: LOGIC_OPERATOR_AND = 1;
   */
  AND = 1,

  /**
   * 2
   *
   * @generated from enum value: LOGIC_OPERATOR_OR = 2;
   */
  OR = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(LogicOperator)
proto3.util.setEnumType(LogicOperator, "constant.LogicOperator", [
  { no: 0, name: "LOGIC_OPERATOR_NONE" },
  { no: 1, name: "LOGIC_OPERATOR_AND" },
  { no: 2, name: "LOGIC_OPERATOR_OR" },
]);

/**
 * MaintenanceType represents string-based constants
 *
 * @generated from enum constant.MaintenanceType
 */
export enum MaintenanceType {
  /**
   * "all"
   *
   * @generated from enum value: MAINTENANCE_TYPE_ALL = 0;
   */
  ALL = 0,

  /**
   * "matching"
   *
   * @generated from enum value: MAINTENANCE_TYPE_MATCHING = 1;
   */
  MATCHING = 1,
}
// Retrieve enum metadata with: proto3.getEnumType(MaintenanceType)
proto3.util.setEnumType(MaintenanceType, "constant.MaintenanceType", [
  { no: 0, name: "MAINTENANCE_TYPE_ALL" },
  { no: 1, name: "MAINTENANCE_TYPE_MATCHING" },
]);

/**
 * MatchType represents string-based constants
 *
 * @generated from enum constant.MatchType
 */
export enum MatchType {
  /**
   * "beginner_match"
   *
   * @generated from enum value: MATCH_TYPE_BEGINNER_MATCH = 0;
   */
  BEGINNER_MATCH = 0,

  /**
   * "random_match"
   *
   * @generated from enum value: MATCH_TYPE_RANDOM_MATCH = 1;
   */
  RANDOM_MATCH = 1,

  /**
   * "rank_match"
   *
   * @generated from enum value: MATCH_TYPE_RANK_MATCH = 2;
   */
  RANK_MATCH = 2,

  /**
   * "event_match"
   *
   * @generated from enum value: MATCH_TYPE_EVENT_MATCH = 3;
   */
  EVENT_MATCH = 3,

  /**
   * "lobby_match"
   *
   * @generated from enum value: MATCH_TYPE_LOBBY_MATCH = 4;
   */
  LOBBY_MATCH = 4,

  /**
   * "cpu_match"
   *
   * @generated from enum value: MATCH_TYPE_C_PUMATCH = 5;
   */
  C_PUMATCH = 5,
}
// Retrieve enum metadata with: proto3.getEnumType(MatchType)
proto3.util.setEnumType(MatchType, "constant.MatchType", [
  { no: 0, name: "MATCH_TYPE_BEGINNER_MATCH" },
  { no: 1, name: "MATCH_TYPE_RANDOM_MATCH" },
  { no: 2, name: "MATCH_TYPE_RANK_MATCH" },
  { no: 3, name: "MATCH_TYPE_EVENT_MATCH" },
  { no: 4, name: "MATCH_TYPE_LOBBY_MATCH" },
  { no: 5, name: "MATCH_TYPE_C_PUMATCH" },
]);

/**
 * MissionTaskType represents int-based constants
 *
 * @generated from enum constant.MissionTaskType
 */
export enum MissionTaskType {
  /**
   * 0
   *
   * @generated from enum value: MISSION_TASK_TYPE_NONE = 0;
   */
  NONE = 0,

  /**
   * 1
   *
   * @generated from enum value: MISSION_TASK_TYPE_REACH_CHARACTER_LEVEL = 1;
   */
  REACH_CHARACTER_LEVEL = 1,

  /**
   * 2
   *
   * @generated from enum value: MISSION_TASK_TYPE_WIN_STREAK = 2;
   */
  WIN_STREAK = 2,

  /**
   * 3
   *
   * @generated from enum value: MISSION_TASK_TYPE_LOSE_STREAK = 3;
   */
  LOSE_STREAK = 3,

  /**
   * 4
   *
   * @generated from enum value: MISSION_TASK_TYPE_USE_ITEM_FILTERED_BY_ID = 4;
   */
  USE_ITEM_FILTERED_BY_ID = 4,

  /**
   * 5
   *
   * @generated from enum value: MISSION_TASK_TYPE_USE_ITEM_FILTERED_BY_ITEM_TYPE = 5;
   */
  USE_ITEM_FILTERED_BY_ITEM_TYPE = 5,

  /**
   * 6
   *
   * @generated from enum value: MISSION_TASK_TYPE_TOTAL_WIN_FILTERED_BY_MATCH_TYPE = 6;
   */
  TOTAL_WIN_FILTERED_BY_MATCH_TYPE = 6,

  /**
   * 7
   *
   * @generated from enum value: MISSION_TASK_TYPE_WIN_STREAK_FILTERED_BY_MATCH_TYPE = 7;
   */
  WIN_STREAK_FILTERED_BY_MATCH_TYPE = 7,

  /**
   * 8
   *
   * @generated from enum value: MISSION_TASK_TYPE_TOTAL_WIN = 8;
   */
  TOTAL_WIN = 8,

  /**
   * 9
   *
   * @generated from enum value: MISSION_TASK_TYPE_TOTAL_LOSE = 9;
   */
  TOTAL_LOSE = 9,
}
// Retrieve enum metadata with: proto3.getEnumType(MissionTaskType)
proto3.util.setEnumType(MissionTaskType, "constant.MissionTaskType", [
  { no: 0, name: "MISSION_TASK_TYPE_NONE" },
  { no: 1, name: "MISSION_TASK_TYPE_REACH_CHARACTER_LEVEL" },
  { no: 2, name: "MISSION_TASK_TYPE_WIN_STREAK" },
  { no: 3, name: "MISSION_TASK_TYPE_LOSE_STREAK" },
  { no: 4, name: "MISSION_TASK_TYPE_USE_ITEM_FILTERED_BY_ID" },
  { no: 5, name: "MISSION_TASK_TYPE_USE_ITEM_FILTERED_BY_ITEM_TYPE" },
  { no: 6, name: "MISSION_TASK_TYPE_TOTAL_WIN_FILTERED_BY_MATCH_TYPE" },
  { no: 7, name: "MISSION_TASK_TYPE_WIN_STREAK_FILTERED_BY_MATCH_TYPE" },
  { no: 8, name: "MISSION_TASK_TYPE_TOTAL_WIN" },
  { no: 9, name: "MISSION_TASK_TYPE_TOTAL_LOSE" },
]);

/**
 * MissionType represents int-based constants
 *
 * @generated from enum constant.MissionType
 */
export enum MissionType {
  /**
   * 0
   *
   * @generated from enum value: MISSION_TYPE_NONE = 0;
   */
  NONE = 0,

  /**
   * 1
   *
   * @generated from enum value: MISSION_TYPE_NORMAL = 1;
   */
  NORMAL = 1,

  /**
   * 2
   *
   * @generated from enum value: MISSION_TYPE_LIMITED_NORMAL = 2;
   */
  LIMITED_NORMAL = 2,

  /**
   * 3
   *
   * @generated from enum value: MISSION_TYPE_DAILY = 3;
   */
  DAILY = 3,

  /**
   * 4
   *
   * @generated from enum value: MISSION_TYPE_WEEKLY = 4;
   */
  WEEKLY = 4,

  /**
   * 5
   *
   * @generated from enum value: MISSION_TYPE_MONTHLY = 5;
   */
  MONTHLY = 5,

  /**
   * 6
   *
   * @generated from enum value: MISSION_TYPE_EVENT = 6;
   */
  EVENT = 6,
}
// Retrieve enum metadata with: proto3.getEnumType(MissionType)
proto3.util.setEnumType(MissionType, "constant.MissionType", [
  { no: 0, name: "MISSION_TYPE_NONE" },
  { no: 1, name: "MISSION_TYPE_NORMAL" },
  { no: 2, name: "MISSION_TYPE_LIMITED_NORMAL" },
  { no: 3, name: "MISSION_TYPE_DAILY" },
  { no: 4, name: "MISSION_TYPE_WEEKLY" },
  { no: 5, name: "MISSION_TYPE_MONTHLY" },
  { no: 6, name: "MISSION_TYPE_EVENT" },
]);

/**
 * NotificationStreamAction represents string-based constants
 *
 * @generated from enum constant.NotificationStreamAction
 */
export enum NotificationStreamAction {
  /**
   * "connect"
   *
   * @generated from enum value: NOTIFICATION_STREAM_ACTION_CONNECT = 0;
   */
  CONNECT = 0,

  /**
   * "heartbeat"
   *
   * @generated from enum value: NOTIFICATION_STREAM_ACTION_HEARTBEAT = 1;
   */
  HEARTBEAT = 1,
}
// Retrieve enum metadata with: proto3.getEnumType(NotificationStreamAction)
proto3.util.setEnumType(NotificationStreamAction, "constant.NotificationStreamAction", [
  { no: 0, name: "NOTIFICATION_STREAM_ACTION_CONNECT" },
  { no: 1, name: "NOTIFICATION_STREAM_ACTION_HEARTBEAT" },
]);

/**
 * NotificationStreamEvent represents string-based constants
 *
 * @generated from enum constant.NotificationStreamEvent
 */
export enum NotificationStreamEvent {
  /**
   * "connected"
   *
   * @generated from enum value: NOTIFICATION_STREAM_EVENT_CONNECTED = 0;
   */
  CONNECTED = 0,

  /**
   * "notification"
   *
   * @generated from enum value: NOTIFICATION_STREAM_EVENT_NOTIFICATION = 1;
   */
  NOTIFICATION = 1,
}
// Retrieve enum metadata with: proto3.getEnumType(NotificationStreamEvent)
proto3.util.setEnumType(NotificationStreamEvent, "constant.NotificationStreamEvent", [
  { no: 0, name: "NOTIFICATION_STREAM_EVENT_CONNECTED" },
  { no: 1, name: "NOTIFICATION_STREAM_EVENT_NOTIFICATION" },
]);

/**
 * NotificationType represents string-based constants
 *
 * @generated from enum constant.NotificationType
 */
export enum NotificationType {
  /**
   * "lobby_invite"
   *
   * @generated from enum value: NOTIFICATION_TYPE_LOBBY_INVITE = 0;
   */
  LOBBY_INVITE = 0,

  /**
   * "friend_request"
   *
   * @generated from enum value: NOTIFICATION_TYPE_FRIEND_REQUEST = 1;
   */
  FRIEND_REQUEST = 1,

  /**
   * "friend_request_accepted"
   *
   * @generated from enum value: NOTIFICATION_TYPE_FRIEND_REQUEST_ACCEPTED = 2;
   */
  FRIEND_REQUEST_ACCEPTED = 2,

  /**
   * "friend_request_rejected"
   *
   * @generated from enum value: NOTIFICATION_TYPE_FRIEND_REQUEST_REJECTED = 3;
   */
  FRIEND_REQUEST_REJECTED = 3,

  /**
   * "system_message"
   *
   * @generated from enum value: NOTIFICATION_TYPE_SYSTEM_MESSAGE = 4;
   */
  SYSTEM_MESSAGE = 4,
}
// Retrieve enum metadata with: proto3.getEnumType(NotificationType)
proto3.util.setEnumType(NotificationType, "constant.NotificationType", [
  { no: 0, name: "NOTIFICATION_TYPE_LOBBY_INVITE" },
  { no: 1, name: "NOTIFICATION_TYPE_FRIEND_REQUEST" },
  { no: 2, name: "NOTIFICATION_TYPE_FRIEND_REQUEST_ACCEPTED" },
  { no: 3, name: "NOTIFICATION_TYPE_FRIEND_REQUEST_REJECTED" },
  { no: 4, name: "NOTIFICATION_TYPE_SYSTEM_MESSAGE" },
]);

/**
 * OSType represents string-based constants
 *
 * @generated from enum constant.OSType
 */
export enum OSType {
  /**
   * "all"
   *
   * @generated from enum value: OS_TYPE_ALL = 0;
   */
  OS_TYPE_ALL = 0,

  /**
   * "apple"
   *
   * @generated from enum value: OS_TYPE_APPLE = 1;
   */
  OS_TYPE_APPLE = 1,

  /**
   * "android"
   *
   * @generated from enum value: OS_TYPE_ANDROID = 2;
   */
  OS_TYPE_ANDROID = 2,

  /**
   * "steam"
   *
   * @generated from enum value: OS_TYPE_STEAM = 3;
   */
  OS_TYPE_STEAM = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(OSType)
proto3.util.setEnumType(OSType, "constant.OSType", [
  { no: 0, name: "OS_TYPE_ALL" },
  { no: 1, name: "OS_TYPE_APPLE" },
  { no: 2, name: "OS_TYPE_ANDROID" },
  { no: 3, name: "OS_TYPE_STEAM" },
]);

/**
 * OrnamentType represents int-based constants
 *
 * @generated from enum constant.OrnamentType
 */
export enum OrnamentType {
  /**
   * 0
   *
   * @generated from enum value: ORNAMENT_TYPE_NONE = 0;
   */
  NONE = 0,

  /**
   * 1
   *
   * @generated from enum value: ORNAMENT_TYPE_ORNAMENT_SHOGI_PIECE = 1;
   */
  ORNAMENT_SHOGI_PIECE = 1,

  /**
   * 2
   *
   * @generated from enum value: ORNAMENT_TYPE_ORNAMENT_SHOGI_PIECE_SOUND = 2;
   */
  ORNAMENT_SHOGI_PIECE_SOUND = 2,

  /**
   * 3
   *
   * @generated from enum value: ORNAMENT_TYPE_ORNAMENT_SHOGI_PIECE_EFFECT = 3;
   */
  ORNAMENT_SHOGI_PIECE_EFFECT = 3,

  /**
   * 4
   *
   * @generated from enum value: ORNAMENT_TYPE_ORNAMENT_SHOGI_INGAME_B_GM = 4;
   */
  ORNAMENT_SHOGI_INGAME_B_GM = 4,

  /**
   * 5
   *
   * @generated from enum value: ORNAMENT_TYPE_ORNAMENT_SHOGI_BOARD = 5;
   */
  ORNAMENT_SHOGI_BOARD = 5,

  /**
   * 6
   *
   * @generated from enum value: ORNAMENT_TYPE_ORNAMENT_ICON = 6;
   */
  ORNAMENT_ICON = 6,

  /**
   * 7
   *
   * @generated from enum value: ORNAMENT_TYPE_ORNAMENT_ICON_FRAME = 7;
   */
  ORNAMENT_ICON_FRAME = 7,

  /**
   * 8
   *
   * @generated from enum value: ORNAMENT_TYPE_ORNAMENT_HOME_BACKGROUND = 8;
   */
  ORNAMENT_HOME_BACKGROUND = 8,
}
// Retrieve enum metadata with: proto3.getEnumType(OrnamentType)
proto3.util.setEnumType(OrnamentType, "constant.OrnamentType", [
  { no: 0, name: "ORNAMENT_TYPE_NONE" },
  { no: 1, name: "ORNAMENT_TYPE_ORNAMENT_SHOGI_PIECE" },
  { no: 2, name: "ORNAMENT_TYPE_ORNAMENT_SHOGI_PIECE_SOUND" },
  { no: 3, name: "ORNAMENT_TYPE_ORNAMENT_SHOGI_PIECE_EFFECT" },
  { no: 4, name: "ORNAMENT_TYPE_ORNAMENT_SHOGI_INGAME_B_GM" },
  { no: 5, name: "ORNAMENT_TYPE_ORNAMENT_SHOGI_BOARD" },
  { no: 6, name: "ORNAMENT_TYPE_ORNAMENT_ICON" },
  { no: 7, name: "ORNAMENT_TYPE_ORNAMENT_ICON_FRAME" },
  { no: 8, name: "ORNAMENT_TYPE_ORNAMENT_HOME_BACKGROUND" },
]);

/**
 * PlatformType represents int-based constants
 *
 * @generated from enum constant.PlatformType
 */
export enum PlatformType {
  /**
   * 0
   *
   * @generated from enum value: PLATFORM_TYPE_NONE = 0;
   */
  NONE = 0,

  /**
   * 1
   *
   * @generated from enum value: PLATFORM_TYPE_IOS = 1;
   */
  IOS = 1,

  /**
   * 2
   *
   * @generated from enum value: PLATFORM_TYPE_ANDROID = 2;
   */
  ANDROID = 2,

  /**
   * 3
   *
   * @generated from enum value: PLATFORM_TYPE_WINDOWS = 3;
   */
  WINDOWS = 3,

  /**
   * 4
   *
   * @generated from enum value: PLATFORM_TYPE_MAC = 4;
   */
  MAC = 4,

  /**
   * 5
   *
   * @generated from enum value: PLATFORM_TYPE_LINUX = 5;
   */
  LINUX = 5,

  /**
   * 6
   *
   * @generated from enum value: PLATFORM_TYPE_WEB = 6;
   */
  WEB = 6,

  /**
   * 7
   *
   * @generated from enum value: PLATFORM_TYPE_OTHER = 7;
   */
  OTHER = 7,

  /**
   * 8
   *
   * @generated from enum value: PLATFORM_TYPE_WINDOWS_EDITOR = 8;
   */
  WINDOWS_EDITOR = 8,
}
// Retrieve enum metadata with: proto3.getEnumType(PlatformType)
proto3.util.setEnumType(PlatformType, "constant.PlatformType", [
  { no: 0, name: "PLATFORM_TYPE_NONE" },
  { no: 1, name: "PLATFORM_TYPE_IOS" },
  { no: 2, name: "PLATFORM_TYPE_ANDROID" },
  { no: 3, name: "PLATFORM_TYPE_WINDOWS" },
  { no: 4, name: "PLATFORM_TYPE_MAC" },
  { no: 5, name: "PLATFORM_TYPE_LINUX" },
  { no: 6, name: "PLATFORM_TYPE_WEB" },
  { no: 7, name: "PLATFORM_TYPE_OTHER" },
  { no: 8, name: "PLATFORM_TYPE_WINDOWS_EDITOR" },
]);

/**
 * PurchaseLimitScopeType represents int-based constants
 *
 * @generated from enum constant.PurchaseLimitScopeType
 */
export enum PurchaseLimitScopeType {
  /**
   * 0
   *
   * @generated from enum value: PURCHASE_LIMIT_SCOPE_TYPE_NONE = 0;
   */
  NONE = 0,

  /**
   * 1
   *
   * @generated from enum value: PURCHASE_LIMIT_SCOPE_TYPE_PLATFORM_SEPARATE = 1;
   */
  PLATFORM_SEPARATE = 1,

  /**
   * 2
   *
   * @generated from enum value: PURCHASE_LIMIT_SCOPE_TYPE_PLATFORM_SHARED = 2;
   */
  PLATFORM_SHARED = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(PurchaseLimitScopeType)
proto3.util.setEnumType(PurchaseLimitScopeType, "constant.PurchaseLimitScopeType", [
  { no: 0, name: "PURCHASE_LIMIT_SCOPE_TYPE_NONE" },
  { no: 1, name: "PURCHASE_LIMIT_SCOPE_TYPE_PLATFORM_SEPARATE" },
  { no: 2, name: "PURCHASE_LIMIT_SCOPE_TYPE_PLATFORM_SHARED" },
]);

/**
 * ShogiPieceRarityType represents int-based constants
 *
 * @generated from enum constant.ShogiPieceRarityType
 */
export enum ShogiPieceRarityType {
  /**
   * 0
   *
   * @generated from enum value: SHOGI_PIECE_RARITY_TYPE_NONE = 0;
   */
  NONE = 0,

  /**
   * 1
   *
   * @generated from enum value: SHOGI_PIECE_RARITY_TYPE_C = 1;
   */
  C = 1,

  /**
   * 2
   *
   * @generated from enum value: SHOGI_PIECE_RARITY_TYPE_R = 2;
   */
  R = 2,

  /**
   * 3
   *
   * @generated from enum value: SHOGI_PIECE_RARITY_TYPE_S_R = 3;
   */
  S_R = 3,

  /**
   * 4
   *
   * @generated from enum value: SHOGI_PIECE_RARITY_TYPE_S_SR = 4;
   */
  S_SR = 4,
}
// Retrieve enum metadata with: proto3.getEnumType(ShogiPieceRarityType)
proto3.util.setEnumType(ShogiPieceRarityType, "constant.ShogiPieceRarityType", [
  { no: 0, name: "SHOGI_PIECE_RARITY_TYPE_NONE" },
  { no: 1, name: "SHOGI_PIECE_RARITY_TYPE_C" },
  { no: 2, name: "SHOGI_PIECE_RARITY_TYPE_R" },
  { no: 3, name: "SHOGI_PIECE_RARITY_TYPE_S_R" },
  { no: 4, name: "SHOGI_PIECE_RARITY_TYPE_S_SR" },
]);

/**
 * SubscriptionIntervalType represents string-based constants
 *
 * @generated from enum constant.SubscriptionIntervalType
 */
export enum SubscriptionIntervalType {
  /**
   * "monthly"
   *
   * @generated from enum value: SUBSCRIPTION_INTERVAL_TYPE_MONTHLY = 0;
   */
  MONTHLY = 0,

  /**
   * "yearly"
   *
   * @generated from enum value: SUBSCRIPTION_INTERVAL_TYPE_YEARLY = 1;
   */
  YEARLY = 1,
}
// Retrieve enum metadata with: proto3.getEnumType(SubscriptionIntervalType)
proto3.util.setEnumType(SubscriptionIntervalType, "constant.SubscriptionIntervalType", [
  { no: 0, name: "SUBSCRIPTION_INTERVAL_TYPE_MONTHLY" },
  { no: 1, name: "SUBSCRIPTION_INTERVAL_TYPE_YEARLY" },
]);

/**
 * SubscriptionType represents string-based constants
 *
 * @generated from enum constant.SubscriptionType
 */
export enum SubscriptionType {
  /**
   * "none"
   *
   * @generated from enum value: SUBSCRIPTION_TYPE_NONE = 0;
   */
  NONE = 0,

  /**
   * "premium_pass"
   *
   * @generated from enum value: SUBSCRIPTION_TYPE_PREMIUM_PASS = 1;
   */
  PREMIUM_PASS = 1,
}
// Retrieve enum metadata with: proto3.getEnumType(SubscriptionType)
proto3.util.setEnumType(SubscriptionType, "constant.SubscriptionType", [
  { no: 0, name: "SUBSCRIPTION_TYPE_NONE" },
  { no: 1, name: "SUBSCRIPTION_TYPE_PREMIUM_PASS" },
]);

/**
 * UserFollowState represents int-based constants
 *
 * @generated from enum constant.UserFollowState
 */
export enum UserFollowState {
  /**
   * 0
   *
   * @generated from enum value: USER_FOLLOW_STATE_NONE = 0;
   */
  NONE = 0,

  /**
   * 1
   *
   * @generated from enum value: USER_FOLLOW_STATE_FOLLOWING = 1;
   */
  FOLLOWING = 1,

  /**
   * 2
   *
   * @generated from enum value: USER_FOLLOW_STATE_PENDING = 2;
   */
  PENDING = 2,

  /**
   * 3
   *
   * @generated from enum value: USER_FOLLOW_STATE_REJECTED = 3;
   */
  REJECTED = 3,

  /**
   * 4
   *
   * @generated from enum value: USER_FOLLOW_STATE_BLOCKED = 4;
   */
  BLOCKED = 4,

  /**
   * 100
   *
   * @generated from enum value: USER_FOLLOW_STATE_MAX_FRIEND_COUNT = 5;
   */
  MAX_FRIEND_COUNT = 5,
}
// Retrieve enum metadata with: proto3.getEnumType(UserFollowState)
proto3.util.setEnumType(UserFollowState, "constant.UserFollowState", [
  { no: 0, name: "USER_FOLLOW_STATE_NONE" },
  { no: 1, name: "USER_FOLLOW_STATE_FOLLOWING" },
  { no: 2, name: "USER_FOLLOW_STATE_PENDING" },
  { no: 3, name: "USER_FOLLOW_STATE_REJECTED" },
  { no: 4, name: "USER_FOLLOW_STATE_BLOCKED" },
  { no: 5, name: "USER_FOLLOW_STATE_MAX_FRIEND_COUNT" },
]);

/**
 * UserMigrateBitType represents int-based constants
 *
 * @generated from enum constant.UserMigrateBitType
 */
export enum UserMigrateBitType {
  /**
   * 0
   *
   * @generated from enum value: USER_MIGRATE_BIT_TYPE_NONE = 0;
   */
  NONE = 0,

  /**
   * 1
   *
   * @generated from enum value: USER_MIGRATE_BIT_TYPE_TEST1 = 1;
   */
  TEST1 = 1,

  /**
   * 2
   *
   * @generated from enum value: USER_MIGRATE_BIT_TYPE_TEST2 = 2;
   */
  TEST2 = 2,

  /**
   * 3
   *
   * @generated from enum value: USER_MIGRATE_BIT_TYPE_TEST3 = 3;
   */
  TEST3 = 3,

  /**
   * 4
   *
   * @generated from enum value: USER_MIGRATE_BIT_TYPE_TEST4 = 4;
   */
  TEST4 = 4,

  /**
   * 5
   *
   * @generated from enum value: USER_MIGRATE_BIT_TYPE_TEST5 = 5;
   */
  TEST5 = 5,

  /**
   * 6
   *
   * @generated from enum value: USER_MIGRATE_BIT_TYPE_TEST6 = 6;
   */
  TEST6 = 6,

  /**
   * 7
   *
   * @generated from enum value: USER_MIGRATE_BIT_TYPE_TEST7 = 7;
   */
  TEST7 = 7,

  /**
   * 8
   *
   * @generated from enum value: USER_MIGRATE_BIT_TYPE_TEST8 = 8;
   */
  TEST8 = 8,
}
// Retrieve enum metadata with: proto3.getEnumType(UserMigrateBitType)
proto3.util.setEnumType(UserMigrateBitType, "constant.UserMigrateBitType", [
  { no: 0, name: "USER_MIGRATE_BIT_TYPE_NONE" },
  { no: 1, name: "USER_MIGRATE_BIT_TYPE_TEST1" },
  { no: 2, name: "USER_MIGRATE_BIT_TYPE_TEST2" },
  { no: 3, name: "USER_MIGRATE_BIT_TYPE_TEST3" },
  { no: 4, name: "USER_MIGRATE_BIT_TYPE_TEST4" },
  { no: 5, name: "USER_MIGRATE_BIT_TYPE_TEST5" },
  { no: 6, name: "USER_MIGRATE_BIT_TYPE_TEST6" },
  { no: 7, name: "USER_MIGRATE_BIT_TYPE_TEST7" },
  { no: 8, name: "USER_MIGRATE_BIT_TYPE_TEST8" },
]);

